import { ButtonHeading, CommonInput, CommonTextarea, CustomPagination, CustomSelect } from 'components'
import Tab from 'components/common/Tab'
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import { constant } from 'constants/constant';
import { AddEditBranch, AddEditEwayBillLrModal, AddEwayBillModal, EbillExtentionModal, EwayBillNewDetailsModal, ExtendEwayBillModal, LrDetailModal } from 'modals';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { IoLocationSharp } from 'react-icons/io5';
import PermissionModal from 'modals/PermissionModal';
import { UserContext } from 'context';
import LoadingBar from 'react-top-loading-bar';
import StorageService from 'utils/StorageServices/StorageServices';
import { changeStatusEwayBillChecker, getEwayBillByDate, getEwayBillList, getEwayBillListByDate, getEwayBillTimeLine } from '_services/accountsServices/ewayBillServices';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import MastersFilterModal from 'modals/MastersFilterModal';
import { getBranchDropdownListData, getConsignorDropdownListData } from '_services/dropdownServices/dropdownService';
import toast from 'react-hot-toast';
import moment from 'moment';
import EwayBillFilterModal from 'modals/EwayBillFilterModal/EwayBillFilterModal';
import TimeLineEwayModal from 'modals/TimeLineEwayModal/TimeLineEwayModal';
import { useNavigate } from 'react-router-dom';
import { actionPermission, errorSchema, utils } from 'helper';
import EwayCheckerTimeLineModal from 'modals/EwayCheckerTimeLineModal/EwayCheckerTimeLineModal';
import { updateEwayCheckerFilters } from 'features/ewayCheckerFilterServices/ewayCheckerFilterSlice';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import AddEwayPartyModal from 'modals/AddEwayPartyModal';

const headerArray = [
    { id: 0, title: "All", value: "all", count: 0, },
    { id: 1, title: "Pending", value: "pending", count: 0, },
    { id: 2, title: "Created", value: "created", count: 0, },
    { id: 3, title: "Ignore", value: "ignore", count: 0, },
]

// const getTodayDate = (date) => {
//     if (date) {
//         const today = new Date(date);
//         const year = today.getFullYear();
//         const month = String(today.getMonth() + 1).padStart(2, "0");
//         const day = String(today.getDate()).padStart(2, "0");
//         return `${day}/${month}/${year}`;
//     }
// }

const getTodayDate = (date) => {
    if (date) {
        const today = new Date(date);
        const year = today.getUTCFullYear();
        const month = String(today.getUTCMonth() + 1).padStart(2, "0");
        const day = String(today.getUTCDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }
};

const EwayBillChecker = () => {

    const [headerCounts, setHeaderCounts] = useState(headerArray);
    const loadingBarRef = useRef(null);
    const prevTripFilterRef = useRef();

    const dispatch = useDispatch();
    const { masterData, setLrDetialsFrom } = useContext(UserContext)
    const getEwayChecker = useSelector((state) => state.ewayChecker)?.filters; // lr_pagination

    const [filterCount, setFilterCount] = useState(0);
    const [ewayBillCheckerList, setEwayBillCheckerList] = useState([]);

    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [listData, setListData] = useState({
        consignorList: [],
        branchList: [],
    });

    const [loading, setLoading] = useState(false);

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    const [toggleEwayBillDropdown, setToggleEwayBillDropdown] = useState(true);

    const [formValue, setFormValue] = useState({
        branch_id: {},
        eway_date: new Date()
    })
    const [formError, setFormError] = useState({});
    const [isOpenTimeLineModal, setIsOpenTimeLineModal] = useState(false);
    const [ewayTimeLineData, setEwayTimeLineData] = useState([])
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [show, setShow] = useState(false);
    // const [showExtendEway, setShowExtendEway] = useState(false);
    const [showEwayTimeline, setShowEwayTimeline] = useState(false);
    const [showEwayBillModel, setShowEwayBillModel] = useState(false)
    const [isAddConsignor, setIsAddConsignor] = useState(false);
    const [showPrefield, setShowingPrefield] = useState(false);
    const [consignorPermission, setConsignorPermission] = useState({});
    const [showEwayBillDetail, setShowEwayBillDetail] = useState(false);

    const [showEwayDetail, setShowEwayDetail] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [showEwayParty, setShowEwayParty] = useState(false);
    // const [showEwayBillModel, setShowEwayBillModel] = useState(false)
    // const [showEwayBillDetail, setShowEwayBillDetail] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });

    const tabProps = {
        tabList: headerCounts,
        callBackTab: (value) => { },
        activeTab: 1,
        ewayBillChecker: true,
    };

    let firstAddEwayBillModal = {
        isOpen: show,
        currentModelClose: true,
        isOpenModelClose: (e) => setShow(false),
        addButtonAction: (e) => setIsAddConsignor(e),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Eway Bill",
        submitTitle: "Fetch Data",
        footerPart: true,
        fetchNextModal: (e) => setShowEwayDetail(e), // setShowEwayBillModel(e)
        manualNextModal: (e) => setShowEwayParty(e), // setShowEwayBillModel(e)
        showPrefield: showPrefield,
    }

    let secondAddEwayBillModal = {
        isOpen: showEwayParty,
        isCurrentModelClose: (e) => { setShow(false); setShowEwayParty(false) },
        // previousModal: (e) => { setShowEwayParty(false); setShow(e) },
        manualNextModal: (e) => setShowEwayBillModel(e),
        addButtonAction: (e) => setIsAddConsignor(e),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Eway Bill Manually",
        submitTitle: "Add Manually",
        footerPart: true,
        showPrefield: showPrefield,
    }

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
        let tabFilter = { ...getEwayChecker, offset: page };
        dispatch(updateEwayCheckerFilters(tabFilter))
    };

    const fetchData = async () => {
        try {
            const [consignorRes, branchRes] =
                await Promise.all([
                    getConsignorList(),
                    getBranchList()
                ]);

            const consignorList = formatList(
                consignorRes?.data?.consignor_list,
                "name",
                "_id",
                "All"
            );
            const branchList = formatList(
                branchRes?.data?.branch_list,
                "branch",
                "_id",
                "All"
            );

            setListData({
                consignorList,
                branchList,
            });

            // setLoading(false);
        } catch (error) {
            // setLoading(false);
        }
    };

    const getConsignorList = async () => {
        let object = { company_id: StorageService.getCompanyId(), firm_id: StorageService.getFirmId() };
        return commonFetchFuction(getConsignorDropdownListData, object);
    };

    const getBranchList = async () => {
        let object = { company_id: StorageService.getCompanyId(), firm_id: StorageService.getFirmId(), };
        return commonFetchFuction(getBranchDropdownListData, object);
    };

    const formatList = (list, labelKey, valueKey, defaultOption = null) => {
        const formattedList = list?.map((item) => ({
            ...item,
            label: item[labelKey],
            value: item[valueKey],
        }));
        return defaultOption
            ? [{ label: defaultOption, value: "" }, ...formattedList]
            : formattedList;
    };

    const commonFetchFuction = async (
        apiMethod,
        payload = {},
        transformer = (res) => res
    ) => {
        try {
            const res = await apiMethod(payload);
            if (res?.responseCode === 200) {
                return transformer(res);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        if (showFilterModal) {
            fetchData();
        }
    }, [showFilterModal])

    const clearFilter = () => {
        setFilter((pre) => ({
            ...pre,
            search: "",
            branch_id: "",
            consignor_id: "",
            start_date: "",
            end_date: "",
            from_location: "",
            to_location: "",
            lr_status: 0,
            pod_status: 0,
            eway_bill_status: 0,
            offset: 1
        }));
        dispatch(updateEwayCheckerFilters({
            search: "",
            branch_id: "",
            consignor_id: "",
            start_date: "",
            end_date: "",
            from_location: "",
            to_location: "",
            lr_status: 0,
            pod_status: 0,
            eway_bill_status: 0,
            offset: 1
        }))
        setFilterCount(0);
    };

    useEffect(() => {
        const prevTripFilter = prevTripFilterRef.current;

        if (JSON.stringify(prevTripFilter) !== JSON.stringify(filter)) {
            const filteredValues = Object.entries(filter)
                .filter(
                    ([key, val]) =>
                        key !== "offset" &&
                        key !== "limit" &&
                        key !== "company_id" &&
                        key !== "eway_bill_status" &&
                        val !== "" &&
                        val !== null &&
                        val !== undefined &&
                        val !== 0
                )
                .map(([_, val]) => val);

            setFilterCount(filteredValues.length);
            prevTripFilterRef.current = filter;
        }
    }, [filter]);

    const handleDetailsAction = (data) => {
        setShowEwayBillDetail(data);
    }

    const handleNextModal = (data) => {
        setShowEwayBillDetail(!showEwayBillDetail);
        setShowEwayBillModel({ ...data, isEwayBillLrEdit: true });
    }

    const fetchEwayBillTimeline = async () => {
        // setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: filter?.limit,
                offset: filter?.offset,
            }
            const res = await getEwayBillTimeLine(object);
            if (res?.responseCode == 200) {
                setEwayTimeLineData(res?.data?.listData)
                // setLoading(false);
            } else {
                // setLoading(false);
            }
        } catch (error) {
            // setLoading(false);
        }
    }

    const fetchEwayBillListByDate = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: filter?.limit,
                offset: filter?.offset,
                search: filter?.search
            }
            const res = await getEwayBillListByDate(object);
            if (res?.responseCode == 200) {
                setEwayBillCheckerList(res?.data?.ewblist);
                let counts = res?.data?.ewb_Count;
                let newArray = [
                    { id: 0, title: "All", value: "all", count: counts?.alleWay ? counts?.alleWay : 0, },
                    { id: 1, title: "Pending", value: "pending", count: counts?.pendingeWay ? counts?.pendingeWay : 0, },
                    { id: 2, title: "Created", value: "created", count: counts?.completedeWay ? counts?.completedeWay : 0, },
                    { id: 3, title: "Ignore", value: "ignore", count: counts?.ignoreeWay ? counts?.ignoreeWay : 0, },
                ]
                setHeaderCounts(newArray);
                setTotalItems(res?.data?.total_count);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.ewayBillChecker);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.ewayBillChecker);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const fetchEwayBillByDate = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                branch_id: formValue?.branch_id?.value,
                eway_date: getTodayDate(formValue?.eway_date),
                firm_id: StorageService.getFirmId()
            }
            const res = await getEwayBillByDate(object);
            if (res?.responseCode == 200) {
                fetchEwayBillListByDate();
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.ewayBillChecker);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            await fetchEwayBillByDate();
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            eway_date: utils.getTodayDate(),
            branch_id: dropdownBranchList[0],
        }))
    }, [dropdownBranchList])

    const getDropdownDataBranchList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                search: "",
            };
            const res = await getBranchDropdownListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.branch_list?.map((el) => {
                    return {
                        label: el?.branch,
                        value: el?._id,
                        is_eway_integration: el?.is_eway_integration
                    }
                })
                setDropdownBranchList(data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        getDropdownDataBranchList();
    }, [])

    useEffect(() => {
        setFilter((s) => ({
            ...s,
            ...getEwayChecker
        }))
        fetchEwayBillTimeline();
        fetchEwayBillListByDate();
    }, [getEwayChecker])

    const statusHandler = async (data, ind) => {
        try {
            let obj = {
                company_id: data?.company_id,
                ewb_id: data?._id,
                ewb_ignore: data?.ewb_ignore ? 0 : 1
            }
            const res = await changeStatusEwayBillChecker(obj);
            if (res?.responseCode === 200) {
                let list = [...ewayBillCheckerList];
                list.splice(ind, 1, { ...list[ind], ewb_ignore: data?.ewb_ignore === 1 ? 0 : 1 })
                setEwayBillCheckerList(list);
                toast.success(`${res?.responseMessage}`);
            } else {
                toast.error('Error !!');
                await fetchEwayBillListByDate();
            }
        } catch (error) {
            toast.error(error.message);
            await fetchEwayBillListByDate();
        }
    }

    const handlePermissionCall = async (e) => {
        e.preventDefault();

        await actionPermission({
            company_id: StorageService.getCompanyId(),
            type: constant?.USABILITY_CONFIG_TYPES?.EWAY_EXTEND,
            onSuccess: () => handleClick(e),
            setModalConfig, // Pass setter
        });
    };

    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <ButtonHeading
                title="Fetch Eway Bill"
                onClick={() => setToggleEwayBillDropdown(!toggleEwayBillDropdown)}
                buttonTitle="Fetch Eway Bill"
                showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                toggleEwayBillDropdown={toggleEwayBillDropdown}
                setFilter={setFilter}
                isDebouncedSearch={false}
                filterCount={filterCount}
                clearFilter={clearFilter}
                isEwayBillChecker={true}
            />

            <div className='__eWay_main_checker'>
                <div className='addPr_flBx_checker'>

                    {toggleEwayBillDropdown ?
                        <div>
                            <div className='pr_procssBx'>
                                <div style={{ display: 'flex' }}>
                                    <div className='pr_procssBx_grid' style={{ minWidth: '500px', maxWidth: '500px' }}>
                                        <div className='halfDiv'>
                                            <DatePickerComponent
                                                label="As of Date "
                                                name="eway_date"
                                                showTimeSelect={false}
                                                defaultTimeFix={false}
                                                startDate={formValue?.eway_date}
                                                onChange={(data) => handleOnChange('eway_date', data)}
                                                error={!!(typeof formError === "object") ? formError?.eway_date : ""}
                                            />
                                            {/* <CommonInput
                                                type="date"
                                                placeholder="As of Date * "
                                                label="As of Date * "
                                                onKeyDown={(e) => e.preventDefault()}
                                                name='eway_date'
                                                value={formValue.eway_date}
                                                focus={!!(typeof formError === "object" && formError?.eway_date)}
                                                error={!!(typeof formError === "object") ? formError?.eway_date : ""}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, value)
                                                }
                                            /> */}
                                        </div>
                                        <div className='halfDiv'>
                                            <CustomSelect
                                                options={dropdownBranchList}
                                                name="branch_id"
                                                label="Select Branch"
                                                placeholder="Select Branch"
                                                value={formValue?.branch_id?.value ? formValue?.branch_id : {}}
                                                error={formError["branch_id.label"]}
                                                onSelect={(data) => onhandleSelect(data, 'branch_id')}
                                            />
                                        </div>
                                    </div>
                                    <div className="_rSideBtn" style={{ marginLeft: '15px' }}>
                                        <button className="_addComm_btn" onClick={(e) => handlePermissionCall(e)} disabled={loading}> {loading ? 'Loading...' : 'Fetch Eway Bill'} </button>
                                    </div>
                                </div>
                                <p className="_lgtText_inDent mt-2 mb-0">
                                    Last Fetch Time {(ewayTimeLineData?.length > 0) ? moment(ewayTimeLineData[0]?.fetch_time).format('DD MMM YYYY') : ''} {ewayTimeLineData[0]?.fetch_time ? '|' : ''} {ewayTimeLineData[0]?.fetch_time ? moment(ewayTimeLineData[0]?.fetch_time).format('hh:mm A') : ''}
                                    &nbsp; Date- {(ewayTimeLineData?.length > 0) ? moment(ewayTimeLineData[0]?.docViewDate).format('DD MMM YYYY') : ''} | GST Number- {ewayTimeLineData[0]?.gst_no ? ewayTimeLineData[0]?.gst_no : '-'}
                                    &nbsp; <span className='ancr_styl' onClick={() => setIsOpenTimeLineModal(ewayTimeLineData)}> View Timeline </span>
                                </p>
                            </div>
                        </div>
                        :
                        <></>
                    }

                    <Tab {...tabProps} />

                    < div className="_indTabl_right">
                        <div className="_indentTable _planLTable">
                            <table className="__tPlain_table">
                                <thead>
                                    <tr>
                                        <th>Eway Bill</th>
                                        <th>Invoice Number</th>
                                        <th>Party</th>
                                        <th>Delivered Location</th>
                                        <th>Expiry Date</th>
                                        <th>Extended Times</th>
                                        <th>LR Status</th>
                                        <th>LR Number</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                {loading ?
                                    <tbody>
                                        <tr>
                                            <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={9}>
                                                <div className='__eWy_detailFx'>
                                                    <div className='__eWy_extOtr'>
                                                        Loading...
                                                    </div>
                                                    <div className='__extensionBx-otr'></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody> :
                                    (ewayBillCheckerList?.length > 0 ?
                                        ewayBillCheckerList?.map((item, index) => {
                                            return (
                                                <React.Fragment key={index}>

                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <div className="_dateNtime">
                                                                    <div className="__locationWid_bx">
                                                                        <p className="_tblText_inDent">
                                                                            {item?.ewbNo ? item?.ewbNo : '-'}
                                                                        </p>
                                                                    </div>

                                                                    <p className="_lgtText_inDent">
                                                                        {item?.ewbDate ? moment(item?.ewbDate).format('DD MMM YYYY') : ''} {item?.ewbDate ? '|' : ''} {item?.ewbDate ? moment(item?.ewbDate).format('hh:mm A') : ''}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="_dateNtime">
                                                                    <div className="__locationWid_bx">
                                                                        <p className="_tblText_inDent">
                                                                            {item?.docNo ? item?.docNo : '-'}
                                                                        </p>
                                                                    </div>

                                                                    <p className="_lgtText_inDent">
                                                                        {item?.docDate ? moment(item?.docDate).format('DD MMM YYYY') : '-'}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td><p className="_tblText_inDent curser_pointer">{item?.lr_id?.consignor_id?.name ? item?.lr_id?.consignor_id?.name : '-'}</p></td>
                                                            <td><p className="_tblText_inDent curser_pointer">{item?.delPlace ? item?.delPlace : '-'}</p></td>
                                                            <td><p className="_tblText_inDent curser_pointer"> {item?.validUpto ? getTodayDate(item?.validUpto) : '-'} </p></td>
                                                            <td><p className="_tblText_inDent curser_pointer">{item?.extendedTimes > 0 ? item?.extendedTimes : 0}</p></td>
                                                            <td><span className={masterData?.lr_status[item?.lr_id?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_id?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_id?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_id?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_id?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '_lrPending_status')))))}> {masterData?.lr_status[item?.lr_id?.lr_status] ? masterData?.lr_status[item?.lr_id?.lr_status] : 'Not found'} </span></td>
                                                            <td>
                                                                {
                                                                    item?.lr_id?.lr_number ?
                                                                        <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction({ ...item, ...item?.lr_id })}>
                                                                            <a className='_avPointer'> {item?.lr_id?.lr_number} </a>
                                                                        </div>
                                                                        :
                                                                        <button className='__add_tbData_btn' onClick={(e) => setShow(item)}> + Add Eway Bill </button>
                                                                }
                                                            </td>
                                                            <td>
                                                                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name="actStatus"
                                                                        id={`actStatus-${item._id}`}
                                                                        autoComplete="off"
                                                                        checked={item?.ewb_ignore}
                                                                        onChange={() => statusHandler(item, index)}
                                                                    />
                                                                    <span className={item?.ewb_ignore ? "disabled_label_masters_status" : "active_label_masters_status"}>
                                                                        {item?.ewb_ignore ? "Ignore" : "Active"}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={9} style={{ padding: '2px', background: '#f7f9ff' }}></td>
                                                        </tr>
                                                    </tbody>
                                                </React.Fragment>
                                            )
                                        })
                                        :
                                        <tbody>
                                            <tr>
                                                <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={9}>
                                                    <div className='__eWy_detailFx'>
                                                        <div className='__eWy_extOtr'>
                                                            No data found
                                                        </div>
                                                        <div className='__extensionBx-otr'></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                            </table>
                        </div>
                    </div>

                    {ewayBillCheckerList?.length > 0 ? <div className='paginationFt_avt'>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter?.offset}
                            onPageChange={handlePageChange}
                        />
                    </div> : <></>}
                </div>
            </div >

            {show
                && (
                    <AddEwayBillModal {...firstAddEwayBillModal} />
                )
            }

            {showEwayParty
                && (
                    <AddEwayPartyModal {...secondAddEwayBillModal} />
                )
            }

            <div
                className={`offcanvas offcanvas-end common_offCanvas slidedOffCanvas ${showEwayDetail ? "open" : ""} ${isClosing ? "closing" : ""}`}
                tabIndex={-1}
                style={{ visibility: showEwayDetail || isClosing ? "visible" : "hidden" }}
            >
                {showEwayDetail &&
                    <EwayBillNewDetailsModal
                        isOpen={showEwayDetail} // { ...showEwayDetail, ...consignorPermission }
                        onClose={() => setShowEwayDetail(false)}
                        fetchNextModal={(e) => setShowEwayBillModel(e)}
                    // previousModel={() => }
                    />}
            </div>

            <div className={showEwayDetail || isClosing ? "offBack_drop " : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showEwayBillModel ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showEwayBillModel ? 'visible' : 'hidden' }}
            >
                {showEwayBillModel
                    && (
                        <AddEditEwayBillLrModal
                            isOpen={showEwayBillModel} // { ...showEwayBillModel, ...consignorPermission }
                            onClose={() => setShowEwayBillModel(false)}
                            callGetData={() => fetchEwayBillListByDate()}
                        />
                    )
                }
            </div>
            <div className={showEwayBillModel ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: isAddConsignor ? 'visible' : 'hidden' }}
            >
                {isAddConsignor &&
                    <AddEditConsignor
                        isOpen={isAddConsignor}
                        onClose={() => setIsAddConsignor(false)}
                        isPreviousModal={(e) => setShow(e)}
                        showingPrefield={(e) => setShowingPrefield(true)}
                        isEwayBillTrue={true}
                        withoutFirstModalDirectLrOpen={(e) => setConsignorPermission(e)}
                        hideAddNewOption={false}
                    />
                }
            </div>
            <div className={isAddConsignor ? 'offBack_drop' : ''}></div>

            {/* <div
                className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showExtendEway ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showExtendEway ? "visible" : "hidden" }}
            >
               {showExtendEway && <ExtendEwayBillModal
                    isOpen={showExtendEway}
                    onClose={(e) => setShowExtendEway(false)}
                />}
            </div>
            <div className={showExtendEway ? "offBack_drop" : ""}></div> */}

            <div
                className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${isOpenTimeLineModal ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: isOpenTimeLineModal ? "visible" : "hidden" }}
            >
                {isOpenTimeLineModal && <EwayCheckerTimeLineModal
                    isOpen={isOpenTimeLineModal}
                    onClose={() => setIsOpenTimeLineModal(false)}
                />}
            </div>
            <div className={isOpenTimeLineModal ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? "visible" : "hidden" }}
            >
                {showFilterModal && (
                    <EwayBillFilterModal
                        isOpen={showFilterModal}
                        onClose={(e) => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={{
                            dateRange: true,
                            consignor: false,
                            isLr_status: false,
                            search: false,
                            allBranch: false,
                            fromLocation: false,
                            toLocation: false,
                            isPod_status: false,
                            isEway_bill_status: false,
                            supplier: false,
                            driver: false,
                            ownership: false,
                            tripStatus: false,
                            vehicle: false
                        }}
                        list={{
                            branch: listData?.branchList,
                            consignor: listData?.consignorList,
                        }}
                        setFilterCount={setFilterCount}
                        name="ewayChecker"
                    />
                )}
            </div>
            <div className={showFilterModal ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showEwayBillDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showEwayBillDetail ? 'visible' : 'hidden' }}
            >
                {showEwayBillDetail
                    && (
                        <LrDetailModal
                            isOpen={showEwayBillDetail}
                            onClose={(e) => setShowEwayBillDetail(false)}
                            nextModal={(e) => handleNextModal(e)}
                            ewayBillStatusDetails={true}
                        />
                    )
                }
            </div>
            <div className={showEwayBillDetail ? 'offBack_drop' : ''}></div>
            {modalConfig.isOpen && <EbillExtentionModal

                {...ebillExpProps} />}
        </>
    )
}

export default React.memo(EwayBillChecker);
